module.exports = __webpack_public_path__ + "static/media/buy-a-food-truck.9c8175d6.jpg";